<script setup lang="ts">
import { computed } from "vue";

import { useDashboardMonoController } from "@/app/data/dashboard/dashboard-mono.controller";
import { EDashboardType } from "@/app/data/dashboard/dashboard.types";
import { useGetHeatmapQuery } from "@/composables/kili/consumption/queries/use-get-heatmap-query";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { TSiteIdsQuery } from "@/data/api/kili/consumption/types/multisite-consumption.type";
import { useTypedIntl } from "@/locales/typed-intl";
import { isDefined } from "@/utils/object";

import HeatmapConsumptionChart from "@/app/data/dashboard/cards/common/heatmap-consumption-chart.vue";

interface IProps {
  siteId: number;
}

const props = defineProps<IProps>();

const { t, k } = useTypedIntl();

const heatmapSiteId = computed<TSiteIdsQuery>(() => {
  return [props.siteId];
});

const { data: heatmapConsumption, isPending: isHeatmapConsumptionPending } = useGetHeatmapQuery(heatmapSiteId);

const { formattedYearConsumptionSerie } = useDashboardMonoController(undefined, undefined, heatmapConsumption);

const title = computed(() =>
  isDefined(heatmapConsumption.value?.source)
    ? t(k.data.dashboard.consumptionHeatmap.title[heatmapConsumption.value.source]({ count: 1 }))
    : t(k.data.dashboard.consumptionHeatmap.title.fallback),
);
</script>

<template>
  <HeatmapConsumptionChart
    :data-test-id="DATA_TEST_IDS.views.dashboard.charts.consumptionHeatmap"
    :is-loading="isHeatmapConsumptionPending"
    :serie="formattedYearConsumptionSerie"
    :title="title"
    :type="EDashboardType.MONOSITE"
  />
</template>
